import { c } from 'react-compiler-runtime';
import { jsx } from 'react/jsx-runtime';
import Box from '../Box/Box.js';

function CircleOcticon(props) {
  const $ = c(21);
  let IconComponent;
  let ariaLabel;
  let as;
  let bg;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      size: t0,
      as,
      icon: IconComponent,
      bg,
      "aria-label": ariaLabel,
      ...rest
    } = props);
    $[0] = props;
    $[1] = IconComponent;
    $[2] = ariaLabel;
    $[3] = as;
    $[4] = bg;
    $[5] = rest;
    $[6] = t0;
  } else {
    IconComponent = $[1];
    ariaLabel = $[2];
    as = $[3];
    bg = $[4];
    rest = $[5];
    t0 = $[6];
  }
  const size = t0 === undefined ? 32 : t0;
  let t1;
  if ($[7] !== IconComponent || $[8] !== ariaLabel || $[9] !== size) {
    t1 = /*#__PURE__*/jsx(IconComponent, {
      size: size,
      "aria-label": ariaLabel
    });
    $[7] = IconComponent;
    $[8] = ariaLabel;
    $[9] = size;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== as || $[12] !== rest || $[13] !== size || $[14] !== t1) {
    t2 = /*#__PURE__*/jsx(Box, {
      display: "flex",
      as: as,
      size: size,
      ...rest,
      alignItems: "center",
      justifyContent: "center",
      children: t1
    });
    $[11] = as;
    $[12] = rest;
    $[13] = size;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== as || $[17] !== bg || $[18] !== size || $[19] !== t2) {
    t3 = /*#__PURE__*/jsx(Box, {
      as: as,
      bg: bg,
      overflow: "hidden",
      borderWidth: 0,
      size: size,
      borderRadius: "50%",
      borderStyle: "solid",
      borderColor: "border.default",
      children: t2
    });
    $[16] = as;
    $[17] = bg;
    $[18] = size;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}

export { CircleOcticon as default };
